import React from 'react';
import PropTypes from 'prop-types';

import { MOST_HELPFUL, NEWEST } from 'constants/appConstants';

import css from 'styles/components/reviews/reviewSort.scss';

const makeSortButton = (props, { testId }, targetOrderingOfThisButton, text, testIdArg) => {
  const { onSortReviewsClick } = props;
  const currentOrdering = props.orderBy || MOST_HELPFUL;
  return (
    <button
      type="button"
      className={css.button}
      disabled={currentOrdering === targetOrderingOfThisButton}
      onClick={onSortReviewsClick.bind(this, targetOrderingOfThisButton)}
      data-test-id={testId(testIdArg)}>{text}</button>
  );
};

const ReviewSort = (props, context) => (
  <div className={css.reviewSort}>
    <span>Sort by:</span>
    {makeSortButton(props, context, MOST_HELPFUL, 'Most Helpful', 'mostHelpfulSort')}
    {makeSortButton(props, context, NEWEST, 'Newest', 'newestSort')}
  </div>
);

ReviewSort.propTypes = {
  orderBy: PropTypes.string,
  onSortReviewsClick: PropTypes.func.isRequired
};

ReviewSort.contextTypes = {
  testId: PropTypes.func
};

export default ReviewSort;
